import { useEffect, useState } from 'react';
import { throttle } from '@helpers/waitFunctions';

const getStickyCss = () => {
  return `l-header-sticky offset-top ${window.scrollY >= 54 ? 'hide-top-bar' : ''}`;
};

export const useStickyHeader = (hasBreadcrumb: boolean, lite: boolean) => {
  const cls = lite ? 'l-header-lite-sticky offset-top hide-top-bar' : 'l-header-sticky offset-top';
  const [stickyCss, setStickyCss] = useState(cls);

  const handleStickyInPageNavigation = () => {
    const header = document.querySelector('.l-header');
    const navElement: HTMLDivElement = document.querySelector('.c-in-page-nav');
    const navList = navElement && navElement.querySelector('.c-in-page-nav-list');
    const { height: headerHeight } = header.getBoundingClientRect();
    const hasNavElement = !!(navList && navList.childElementCount > 0);
    const moveInPageNav = window.pageType !== 'SearchPage';

    // Logic to control inPageNavigation visibility
    if (headerHeight && hasNavElement && navElement.style.visibility !== 'visible') {
      if (moveInPageNav) {
        header.appendChild(navElement);
      }
      navElement.classList.add('visible');
    }
  };

  function setHeaderHeightForScroll() {
    const root = document.documentElement;
    const headerHeight = (document.querySelector('.l-header') as HTMLElement).offsetHeight;
    root.style.setProperty('--header-height-for-scroll', headerHeight + 'px');
  }

  const handleScroll = () => {
    const newStickyCss = getStickyCss();
    if (stickyCss !== newStickyCss) {
      setStickyCss(newStickyCss);
    }
  };

  useEffect(() => {
    handleScroll();
  }, []);

  useEffect(() => {
    if (!lite) {
      handleStickyInPageNavigation();
    }

    const barElement = document.getElementById('l-header-sticky-wrapper');

    if (barElement) {
      if (hasBreadcrumb) {
        barElement.classList.add('l-header-conditional-sticky-wrapper');
      } else {
        barElement.classList.remove('l-header-conditional-sticky-wrapper');
      }
    }
  }, [hasBreadcrumb]);

  useEffect(() => {
    setHeaderHeightForScroll();

    const throttledScroll = throttle(handleScroll, 300);
    const throttledHandleInPageNav = throttle(handleStickyInPageNavigation, 300);
    const throttledSetHeaderHeightForScroll = throttle(setHeaderHeightForScroll, 1000);

    window.addEventListener('resize', throttledSetHeaderHeightForScroll);
    window.addEventListener('scroll', throttledScroll);
    if (!lite) {
      window.addEventListener('resize', throttledHandleInPageNav);
    }

    return () => {
      window.removeEventListener('resize', throttledSetHeaderHeightForScroll);
      window.removeEventListener('scroll', throttledScroll);
      if (!lite) {
        window.removeEventListener('resize', throttledHandleInPageNav);
      }
    };
  }, []);

  return { stickyCss, handleScroll };
};
